'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalendarDayOutline, iconCalendarDayOutlineTag } from '@ni/nimble-components/dist/esm/icons/calendar-day-outline';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalendarDayOutline };
export { iconCalendarDayOutlineTag };
export const NimbleIconCalendarDayOutline = wrap(IconCalendarDayOutline);